module.exports = __webpack_public_path__ + "img/slider_5.cf64855c.jpg";